<template>
    <Modal v-if="show" @close="closeModal">
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <div>
          I agree to allow Pack Yuh Barrel to remove the outer packaging from my packages to provide more space in my barrel, and I confirm that the 
          contents of my package(s) are authorized for barrel shipping
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-primary" @click="closeModal">Close</button>
      </template>
    </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
    components: {
        Modal,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        closeModal() {
            this.$emit("close");
        }
    },
}
</script>

<style lang="scss" scoped>

</style>